import * as THREE from 'three'

const lightsConfig = {
  blueLight: {
      position :{
          x: 2,
          y: 6,
          z: 1
      },
      color: "#3366ff",
      intensity: 0.18
  },
  redLight: {
      position :{
          x: -2,
          y: 0.9,
          z: 1.3
      },
      color: "#96aadc",
      intensity: 0.3
  }
}

const createLights = (scene, gui) => {
  const lights = new THREE.Group()
  scene.add(lights)

  const ambientLight = new THREE.AmbientLight('#ff6633', 0.5)
  lights.add(ambientLight)

  const blueLight = new THREE.PointLight(
      lightsConfig.blueLight.color, 
      lightsConfig.blueLight.intensity
  )
  lights.add(blueLight)

  const redLight = new THREE.PointLight(
      lightsConfig.redLight.color,
      lightsConfig.redLight.intensity
  )
  lights.add(redLight)

  const updateLight = () => {
      updateLightsToConfig([{
          light: blueLight, 
          config: lightsConfig.blueLight
      },{
          light: redLight, 
          config: lightsConfig.redLight
      }])
  }

  const blueLightFolder = gui.addFolder('blue light')
  blueLightFolder.add(lightsConfig.blueLight.position, 'x')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  blueLightFolder.add(lightsConfig.blueLight.position, 'y')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  blueLightFolder.add(lightsConfig.blueLight.position, 'z')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  blueLightFolder.add(lightsConfig.blueLight, 'intensity')
      .min(0).max(1).step(0.01).onChange(updateLight)
  blueLightFolder.addColor(lightsConfig.blueLight, 'color').onChange(updateLight)

  const redLightFolder = gui.addFolder('red light')
  redLightFolder.add(lightsConfig.redLight.position, 'x')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  redLightFolder.add(lightsConfig.redLight.position, 'y')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  redLightFolder.add(lightsConfig.redLight.position, 'z')
      .min(-20).max(20).step(0.01).onChange(updateLight)
  redLightFolder.add(lightsConfig.redLight, 'intensity')
      .min(0).max(1).step(0.01).onChange(updateLight)
  redLightFolder.addColor(lightsConfig.redLight, 'color').onChange(updateLight)

  updateLight()

  return lights
}


const updateLightsToConfig = (lights) => {
  lights.map(({config, light}) => {
    light.intensity = config.intensity
    light.color = new THREE.Color(config.color)
    light.position.set(
        config.position.x, 
        config.position.y,
        config.position.z
    )
  })
}

export {
  lightsConfig,
  createLights,
  updateLightsToConfig
}